import { ResourceOptions } from 'react-admin';
import '../dataProvider';
import { Resources } from '../../resource';

// Pools are shown as a tab inside the Proxy Manager page (see ProxyManagerPage).
// This resource is registered without a list route so its data provider / store keys work.
export const name = Resources.proxyManagerPools;
export const options: ResourceOptions = {
  label: 'resource.proxyManagerPools',
};
